export const defaultState = () => {
  return {
    myActiveGiftCards: {},
    selectedGiftCardForCheckout: null,
    selectedExternalGiftCardForCheckout: null,
    useGiftCardForCheckout: false,
    isCurrencyInputFocused: false,
    giftCards: [],
    loading: false,
    detailLoading: false,
    giftCardDetails: {},
  }
}

export default defaultState()
